import React, { useEffect, createElement } from 'react';
import { HeroSection } from './HeroSection';
import { PainPoints } from './PainPoints';
import { SolutionSection } from './SolutionSection';
import { ProductBreakdown } from './ProductBreakdown';
import { BenefitsSection } from './BenefitsSection';
import { TestimonialsSection } from './TestimonialsSection';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FAQSection } from './FAQSection';
import { SocialProofPopup } from './SocialProofPopup';
import { CTAButton } from './ui/CTAButton';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel Code - Safe initialization for React
    const initFacebookPixel = () => {
      // Initialize fbq function
      if (!window.fbq) {
        const fbq: any = function () {
          fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        window.fbq = fbq;
        window._fbq = fbq;
      }
      // Load the Facebook Pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Initialize pixel and track page view
      window.fbq('init', '2002471603943869');
      window.fbq('track', 'PageView');
      console.log('Meta Pixel initialized with ID: 2002471603943869');
    };
    initFacebookPixel();
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-yellow-200" data-id="element-79">
      <HeroSection data-id="element-80" />
      <PainPoints data-id="element-81" />
      <SolutionSection data-id="element-82" />
      <ProductBreakdown data-id="element-83" />
      <BenefitsSection data-id="element-84" />
      <TestimonialsSection data-id="element-85" />
      <BonusSection data-id="element-86" />
      <PricingSection data-id="element-87" />
      <GuaranteeSection data-id="element-88" />
      <FAQSection data-id="element-89" />

      {/* Final CTA Section */}
      <section className="bg-gray-900 py-20 text-center text-white" data-id="element-90">
        <div className="mx-auto max-w-4xl px-4" data-id="element-91">
          <h2 className="mb-6 text-3xl font-bold md:text-4xl" data-id="element-92">
            No necesitás ser perfecto
          </h2>
          <h3 className="mb-8 text-2xl font-medium text-gray-300 md:text-3xl" data-id="element-93">
            Necesitás tener recursos
          </h3>
          <p className="mb-12 text-lg text-gray-400" data-id="element-94">
            El aula no espera. Los conflictos no avisan. La improvisación
            desgasta. <br data-id="element-95" />
            <span className="font-bold text-white" data-id="element-96">
              👉 Este kit existe para acompañarte cuando el aula tiembla.
            </span>
          </p>

          <div className="mb-8" data-id="element-97">
            <h4 className="text-2xl font-bold text-yellow-400" data-id="element-98">
              MEGA KIT SUPERVIVENCIA DOCENTE
            </h4>
            <div className="mt-4 flex justify-center gap-6 text-sm" data-id="element-99">
              <span data-id="element-100">📥 Descarga inmediata</span>
              <span data-id="element-101">🛡️ Garantía 7 días</span>
            </div>
          </div>

          <CTAButton className="text-xl px-12" data-id="element-102">QUIERO MI KIT AHORA</CTAButton>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-8 text-center text-sm text-gray-600" data-id="element-103">
        <p data-id="element-104">
          © {new Date().getFullYear()} Mega Kit Docente. Todos los derechos
          reservados.
        </p>
      </footer>

      <SocialProofPopup data-id="element-105" />
    </div>;
}